export interface RemoteConfigValues {
  // Backend Configuration
  api_base_url: string;

  // add more types here according to firebase console
}

export type RemoteConfigKey = keyof RemoteConfigValues;

export const DEFAULT_REMOTE_CONFIG: RemoteConfigValues = {
  // Backend Configuration
  api_base_url: import.meta.env.VITE_API_BASE_URL || '',

  // add more defaults here
};
